import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items = [] }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const content = item.href && !isLast ? (
            <Link
              to={item.href}
              className="transition-colors hover:text-slate-800"
            >
              {item.label}
            </Link>
          ) : (
            <span className={isLast ? 'text-slate-800' : ''}>{item.label}</span>
          );

          return (
            <li key={`${item.label}-${item.href || index}`} className="flex items-center gap-2">
              {content}
              {!isLast && <ChevronRight size={12} className="text-slate-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;

